<template>
  <div :class="bem()">
    <VisionHeading
      tag="h4"
      size="h4"
    >
      Did this answer your question?
    </VisionHeading>

    <div :class="bem('rating')">
      <button
        :class="bem('button', { faded: isFaded(-1) })"
        @click="submitRating(-1)"
      >
        <span title="Disappointed">😞</span>
      </button>
      <button
        :class="bem('button', { faded: isFaded(0) })"
        @click="submitRating(0)"
      >
        <span title="Neutral">😐</span>
      </button>
      <button
        :class="bem('button', { faded: isFaded(1) })"
        @click="submitRating(1)"
      >
        <span title="Satisfied">😊</span>
      </button>
    </div>
  </div>
</template>

<script setup>
const bem = useBEM('SupportRating')
const userStore = useUserStore()

const loaded = ref(false)

onMounted(() => {
  loaded.value = true
})

const props = defineProps({
  article: { type: Object, required: true },
})

async function submitRating (rating) {
  if (rating === -1) window.Intercom?.('showNewMessage')

  const { $track } = useNuxtApp()
  userStore.rateSupportArticle(props.article.id, rating)
  await $track.support.rateArticle(props.article, rating)
}

const rating = computed(() => {
  return userStore.supportArticleRatings[props.article.id]
})

function isFaded (value) {
  if (!loaded.value) return false
  if (rating.value === undefined || rating.value === null) return false
  return rating.value !== value
}
</script>

<style lang="postcss">
.SupportRating {
  @apply grow overflow-hidden
    border border-solid border-grey-400
    shadow-sm
    rounded-md
    no-underline
    flex flex-col gap-2
    p-xs sm:p-sm
    text-center;
}

.SupportRating__rating {
  @apply flex justify-center gap-4;
}

.SupportRating__button {
  @apply text-[2.2rem]
    transition-transform transform scale-100;

  &--faded {
    @apply opacity-50 scale-75 grayscale;
  }

  &:hover {
    @apply scale-110;
  }
}
</style>